(function () {
  'use strict';

  angular.module('dashboard.main').factory('DashboardMain', DashboardMain);

  DashboardMain.$inject = ['$resource'];

  function DashboardMain($resource) {
    return $resource(
      '/api/',
      {},
      {
        getLastXDays: {
          method: 'GET',
          url: '/api/dashboard/statistic/lastXDays/:days',
          isArray: true,
        },
      },
    );
  }
})();
